<template>

  <div v-if="filled">
    <div class="card-header">
      <strong>{{ $t('Answers') }}</strong>
    </div>
    <ul
      class="list-group list-group-flush"
      v-if="showAnswers">
      <li
        class="list-group-item"
        :class="{'list-group-item-danger': answer.disqualify && answer.value===false}"
        v-for="(answer, index) in application_answers">
        <div>
          <strong>{{ answer.label }}</strong>
        </div>
        <div v-if="answer.type==='text'">
          {{ answer.value }}
        </div>
        <div v-if="answer.type==='textarea'">
          <span style="white-space: pre-wrap;">{{ answer.value }}</span>
        </div>
        <div v-if="answer.type==='radio'">
          <div
            class="alert my-1 p-2" 
            v-for="(option, option_index) in answer.options"
            :key="option_index"
            :class="checkChoice(option.label, answer.value, option.isDisqualifier)">
            {{ option.label }} <span v-if="option.isDisqualifier">(Desclassificatória)</span>
          </div>
        </div>
        <div v-if="answer.type==='checkbox'">
          <div 
            class="alert my-1 p-2" 
            v-for="(option, option_index) in answer.options"
            :key="option_index"
            :class="checkChoice(option.label, answer.value, option.isDisqualifier)">
            {{ option.label }} <span v-if="option.isDisqualifier">(Desclassificatória)</span>
          </div>
        </div>
        <div v-if="answer.type==='boolean'">
          <div 
            class="alert my-1 p-2" 
            :class="checkChoice(true, answer.value)">
            {{ $t('Yes') }} <span v-if="answer.disqualifyOn === 'yes'">(Desclassificatória)</span>
          </div>
          <div
            class="alert my-1 p-2" 
            :class="checkChoice(false, answer.value)">
            {{ $t('No') }} <span v-if="answer.disqualifyOn === 'no'">(Desclassificatória)</span>
          </div>
        </div>
      </li>
    </ul>
    <button
      class="btn btn-light btn-block"
      @click="showAnswers=!showAnswers"
      style="font-weight: bold;">
        <span v-if="!showAnswers">{{ $t('Show answers') }}</span>
        <span v-if="showAnswers">{{ $t('Hide answers') }}</span>
      </button>
  </div>

</template>

<script>
export default {
  name: 'CandidateProfileAnswers',
  components: {
  },
  data () {
    return {
      showAnswers: false
    }
  },
  created () {
  },
  computed: {
    candidateJobId () {
      return this.$route.query.candidate_job_id
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    placement () {
      if (!this.candidateJobId) return null
      return this.candidate.placements.find((placement) => {
        return placement.job_id === this.candidateJobId
      })
    },
    filled () {
      return this.placement && this.placement.application_answers && Object.keys(this.placement.application_answers).length
    },
    application_answers () {
      return this.placement.application_answers
    }
  },
  methods: {
    checkChoice (option, answer) {
      const check = answer && Array.isArray(answer)
      ? answer.includes(option)
      : option === answer

      return check ? 'alert-info' : 'alert-light'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Profile/CandidateProfileAnswers.vue